import { apiGet, apiPatch, apiPost } from 'shared/services/api/resource';
import { MOCK_ARENA_MURAL_POSTS } from 'modules/arena/mural/content';
import { ArenaMuralPost } from 'modules/arena/mural/types';

function createId() {
  return `aviso-${Math.random().toString(36).slice(2, 9)}`;
}

export function fetchArenaMuralPosts(): Promise<ArenaMuralPost[]> {
  return apiGet(MOCK_ARENA_MURAL_POSTS, '/arena/mural');
}

export function publishAnnouncement(text: string): Promise<ArenaMuralPost> {
  const newPost: ArenaMuralPost = {
    id: createId(),
    kind: 'aviso',
    authorName: 'Arena Praia Norte',
    isOfficial: true,
    timeAgoLabel: 'agora',
    text,
    state: 'ativo',
    reportCount: 0,
  };

  return apiPost(newPost, '/arena/mural', { text });
}

export function updateMuralPostState(id: string, state: ArenaMuralPost['state']) {
  return apiPatch({ id, state }, `/arena/mural/${id}`, { state });
}

export function resolveMuralReport(id: string) {
  return apiPatch({ id, reportCount: 0 }, `/arena/mural/${id}/reports`, { reportCount: 0 });
}
